<template>
  <div class="noticeDetails">
    <p class="title">系统更新</p>
    <p>尊敬的用户：</p>
    <p class="hello">您好！</p>
    <div v-html="str" class="content"></div>
  </div>
</template>
<script lang="ts" setup>
import noticeApi from "@/api/noticeApi/noticeApi";
import { onMounted, ref } from "vue";

const props = defineProps({
  cContent: String,
  cNoticesId: String,
});
console.log(props.cContent);
const str = ref("");
onMounted(() => {
  str.value = props.cContent?.replace(/<img src="(\/)+ueditor/g, `<img src="${import.meta.env.VITE_APP_IMG_SRC}/ueditor`) || "";
  // const arr = props.cContent?.matchAll(/<img src="/g);
  // let o = arr?.next();
  // console.log(arr);

  // while (!o?.done) {
  //   const n = o?.value[0] || "";
  //   o = arr?.next();
  // }
});

if (props.cNoticesId) {
  const params = { cnoticeid: props.cNoticesId };
  noticeApi.AddUserKnowMsgLog(params);
  noticeApi.AddUserReadMsgLog(params);
}
</script>
<style lang="less" scope>
.noticeDetails {
  padding: 0 20px;
  .title {
    font-size: 18px;
    text-align: center;
  }
  .hello {
    margin-left: 2rem;
    line-height: 3;
  }
  .content {
    font-size: 16px;
    text-indent: 2rem;
  }
}
</style>
